module.exports = require("./ar-PS.js");